<template>
    <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg modal-fullscreen-lg-down">
            <div class="modal-content">
                <div class="modal-header bg-primary text-light">
                    <h5 class="modal-title" id="staticBackdropLabel">Carga Masiva con Archivo</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                
                <div class="modal-body">
                    <!-- Company Selection -->
                    <div v-if="empresas.length > 0" class="mb-4">
                        <div class="form-group">
                            <label class="form-label" for="empresa">Seleccionar empresa</label>
                            <select v-model="selectedUrl" class="form-control" @change="updateDropzoneUrl">
                                <option value="">Seleccionar empresa para la carga masiva</option>
                                <option v-for="client in empresas" :key="client.id" :value="client.url">
                                    {{ client.client }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <!-- Dropzone -->
                    <vue-dropzone
                        ref="dropzone"
                        id="dropzone"
                        :options="dropzoneOptions"
                        :useCustomSlot="true"
                        @vdropzone-success="handleSuccess"
                        @vdropzone-error="handleError"
                        class="dropzone-container"
                    >
                        <div class="dropzone-custom-content">
                            <div class="text-center">
                                <i class="zmdi zmdi-cloud-upload text-primary" style="font-size: 48px;"></i>
                                <h4 class="mt-3 mb-2">¡Arrastra y suelta para subir el archivo CSV de los Usuarios!</h4>
                                <p class="text-muted">...o haga clic para seleccionar un archivo de su computadora</p>
                            </div>
                        </div>
                    </vue-dropzone>
                </div>
                
                <div class="modal-footer">
                    <a href="/templates/template_carga_de_usuarios_masivos.csv" download target="_blank" class="btn btn-secondary">
                        Descargar plantilla
                    </a>
                    <button type="button" class="btn btn-outline-primary" data-bs-dismiss="modal">
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
    name: 'MasiveCharge',
    
    components: {
        vueDropzone: vue2Dropzone
    },
    
    props: {
        token: { type: String, required: true },
        url: { type: String, required: true },
        empresas: { type: Array, default: () => [] }
    },
    
    data() {
        return {
            selectedUrl: this.url,
            dropzoneOptions: {
                url: this.url,
                addRemoveLinks: true,
                thumbnailWidth: 150,
                uploadMultiple: false,
                maxFiles: 1,
                acceptedFiles: '.csv',
                maxFilesize: 10,
                headers: {
                    'X-CSRF-TOKEN': this.token
                },
                dictDefaultMessage: 'Arrastra archivos aquí o haz clic para subir',
                dictFileTooBig: 'El archivo es muy grande ({{filesize}}MB). Tamaño máximo: {{maxFilesize}}MB.',
                dictInvalidFileType: 'Solo se permiten archivos CSV.',
                dictMaxFilesExceeded: 'Solo puedes subir un archivo a la vez.'
            }
        };
    },
    
    mounted() {
        this.checkAutoOpen();
    },
    
    methods: {
        updateDropzoneUrl() {
            if (this.$refs.dropzone) {
                this.$refs.dropzone.dropzone.options.url = this.selectedUrl;
            }
        },
        
        handleSuccess(file, response) {
            const message = typeof response === 'object' ? response.message : response;
            this.$swal({
                title: 'Éxito',
                text: message || 'Carga masiva realizada correctamente',
                icon: 'success',
                confirmButtonText: 'Aceptar'
            });
            
            this.$emit('upload-success', response);
            this.removeFile(file);
        },
        
        handleError(file, errorMessage) {
            const message = typeof errorMessage === 'object' ? errorMessage.message : errorMessage;
            this.$swal({
                title: 'Error',
                text: message || 'Error al procesar el archivo',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            });
            
            this.$emit('upload-error', errorMessage);
            this.removeFile(file);
        },
        
        removeFile(file) {
            if (this.$refs.dropzone) {
                this.$refs.dropzone.removeFile(file);
            }
        },
        
        checkAutoOpen() {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('openModal')) {
                const button = document.getElementById('OpenModalButton');
                if (button) button.click();
            }
        }
    }
};
</script>

<style scoped>
.dropzone-container {
    margin-top: 1rem;
    border: 2px dashed #007bff;
    border-radius: 8px;
    background-color: #f8f9fa;
    transition: all 0.3s ease;
}

.dropzone-container:hover {
    border-color: #0056b3;
    background-color: #e3f2fd;
}

.dropzone-custom-content {
    padding: 2rem;
    text-align: center;
}

.form-group {
    margin-bottom: 1rem;
}

.form-label {
    font-weight: 500;
    margin-bottom: 0.5rem;
}

.modal-footer .btn {
    margin-left: 0.5rem;
}

.text-muted {
    color: #6c757d !important;
}
</style>
